import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames';
import { Label } from 'synfrastructure';

class ReduxFormInput extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    subtext: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    required: PropTypes.bool,
  };

  static defaultProps = {
    children: null,
    className: null,
    disabled: false,
    label: null,
    subtext: null,
    required: false,
  };

  render() {
    const { label, children, className, disabled, input, meta: { touched, error }, subtext, required } = this.props;

    const scaffoldClasses = {
      'input-scaffold': true,
      [className]: className,
    };

    const labelClasses = {
      input: true,
      'input--disabled': disabled,
    };

    return (
      <div className={classNames(scaffoldClasses)}>
        <Label className={classNames(labelClasses)}>
          {label ? (
            <span className="input-label">
              {label} {required && <span className="input-required">REQUIRED</span>}
            </span>
          ) : null}
          {subtext ? <span className="input-subtext">{subtext}</span> : null}
          {React.cloneElement(children, input)}
        </Label>
        {touched && error ? <div className="input-validation">{error}</div> : null}
      </div>
    );
  }
}

export default ReduxFormInput;



// WEBPACK FOOTER //
// ./src/common/forms/ReduxFormInput.js